import React from 'react';
import ErrorPage from "../pages/error/ErrorPage";
import { useNavigate } from 'react-router-dom';

const ErrorHandler = ({ error, resetErrorBoundary }) => {
    const navigate = useNavigate();

    const errorInfo = [
        {code: 401, title: 'Unauthorized', description: 'Your login session has expired. Please log in again.', action: () => navigate('/')},
        {code: 403, title: 'Forbidden', description: 'Access is denied. Check your account permissions', action: () => navigate(-1)},
        {code: 404, title: 'Page Not Found', description: 'Sorry, the page you requested cannot be found.', action: () => navigate(-1)},
        {code: 500, title: 'Internal Server Error', description: 'The website cannot display this page. Please try again or contact system administrator.', action: () => navigate(-1)},
    ]

    const errorStatus = error?.response?.status || 500;
    const selectedError = errorInfo.find(e => e.code === errorStatus) || errorInfo[3];

    return <ErrorPage title={selectedError.title} description={selectedError.description} reset={resetErrorBoundary} action={selectedError.action} />
};

export default ErrorHandler;